export const SET_USER = "SET_USER";

export const SET_SNACKBAR = "SET_SNACKBAR";

export const ADD_TO_BOOKMARK = "ADD_TO_BOOKMARK";

export const REMOVE_FROM_BOOKMARK = "REMOVE_FROM_BOOKMARK";

export const CLEAR_BOOKMARK = "CLEAR_BOOKMARK";
